import {lazyRegister} from '@/Core/lazyRegister';
import {BaseApiFactory} from "@/Factories/BaseApiFactory";
import {CustomerShipTo} from "@/models/CustomerShipTo";

export class ShipToService {
    public static readonly $inject = ['BaseApiFactory'];

    constructor(private baseApiFactory: BaseApiFactory) {
    }

    public GetAllShipToByDistributorNumber(distributorNumber: string) {
        return this.baseApiFactory.getData<CustomerShipTo[]>('/api/CustomerShipTo?distributorNumber=' + distributorNumber);
    }
}

lazyRegister.service('ShipToService', ShipToService);
